<template>
  <v-chip
    :color="color"
    class="status-block"
  >
    {{ label }}
  </v-chip>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.status-block {
  color: #fff!important;
  font-weight: bold;
  text-transform: uppercase;
}

@media print {
  .status-block span {
    color: #222;
  }
}
</style>
